import axios from 'axios'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {
count:false
}

const mutations = {
GET_MOBILE(state,data) {
if(data == 1) {
  state.count = true
}else {
  state.count = false
}
}
}

 // + data.mobile + '&password=' + data.password + '&password2=' + data.password2 + '&sms_code=' + data.sms_code + '&username=' + data.username + '&allow=on'
const actions = {
  // 表单提交
  getRegister ({ commit }, data) {
    // console.log(data)
    commit('SIGN')
    return axios.post( '/register/', data).then((res) => {
      // console.log(response.data)
      return res
    })
  },
  // 获取验证码
  verificationmobile ({ commit }, data) {
    // console.log(data)
    commit('VERIFICATION_MOBILE')
    return  axios.get('/sms_code/?mobile='+ data.mobile + '&num=' + data.num + '&code=' + data.code).then((res)=> {
      // console.log(response.data.errmsg)
      return res
    })
  },
  //测试手机号是否被注册
  getmobile({ commit },data) {
    commit('GET_MOBILE')
    // mobile/(?P<mobile>1[3-9]\d{9})/count/
    // console.log(data)
    return axios.get('mobile/' + data +'/count/').then((res) => {
      // commit('GET_MOBILE',res.data.count)
      return res
    })
  }
}

const getters = {
// GET_MOBILE(state,data) {
//   console.log(data)
// }

}

const RegisterModule = {
  state,
  mutations,
  actions,
  getters
}

export default RegisterModule
